import { MarkdownEditor } from '@chipinside/markdown'
import { FormHelperText, styled } from '@mui/material'
import FormLabel from '@mui/material/FormLabel'
import React from 'react'

const StyledFormLabel = styled(FormLabel)({
  fontSize: 12,
  position: 'relative',
  color: '#616161',
})

// preview: 'edit' | 'preview' | 'live'
// hideToolbar: boolean
const TextEditor = ({
  label,
  value,
  defaultValue,
  onChange,
  error,
  preview,
  hideToolbar,
  ...rest
}) => {
  const initial = value || defaultValue
  const [selectedVal, setSelectedVal] = React.useState(initial ? String(initial) : '')

  const handleChange = value => {
    setSelectedVal(value)
    if (onChange) {
      onChange(value)
    }
  }

  React.useEffect(() => {
    setSelectedVal(value ?? '')
  }, [value])

  return (
    <div>
      <StyledFormLabel required={rest.required} error={Boolean(error)}>
        {label}
      </StyledFormLabel>
      <MarkdownEditor
        value={selectedVal}
        onChange={handleChange}
        preview={preview}
        hideToolbar={hideToolbar}
      />

      {error && <FormHelperText error={Boolean(error)}>{error}</FormHelperText>}
    </div>
  )
}

export default TextEditor
